"use strict";
exports.__esModule = true;
exports.APIPathFragments = void 0;
var APIPathFragments;
(function (APIPathFragments) {
    APIPathFragments["DEFAULT"] = "_default";
    APIPathFragments["V1"] = "v1";
    APIPathFragments["USERS"] = "users";
    APIPathFragments["CRM"] = "crm";
    APIPathFragments["OBJECTS"] = "objects";
    APIPathFragments["CONTACTS"] = "contacts";
    APIPathFragments["APP_USERS"] = "app-users";
    APIPathFragments["APP_INFO"] = "app-info";
    APIPathFragments["BULK"] = "bulk";
    APIPathFragments["CREATE"] = "create";
    APIPathFragments["UPDATE"] = "update";
    APIPathFragments["ARCHIVE"] = "archive";
    APIPathFragments["SEARCH"] = "search";
    APIPathFragments["FIELDS"] = "fields";
    APIPathFragments["ACTIVITIES"] = "activities";
    APIPathFragments["ACTIVITY_DEFINITIONS"] = "activity-definitions";
    APIPathFragments["MANAGE_VIEWS"] = "manage-views";
    APIPathFragments["ORGANISATIONS"] = "organisations";
    APIPathFragments["ORGANISATION_MEMBER"] = "organisation-member";
    APIPathFragments["FIELD_GROUPS"] = "field-groups";
    APIPathFragments["FIELD_VALIDATION"] = "field-validation";
    APIPathFragments["ENTITY_CONFIGURATIONS"] = "entity-configurations";
    APIPathFragments["ADD"] = "add";
    APIPathFragments["VIEW"] = "view";
    APIPathFragments["LIST"] = "list";
    APIPathFragments["INVITE"] = "invite";
    APIPathFragments["MARKETPLACE"] = "marketplace";
    APIPathFragments["INSTALLED_APPS"] = "installed-apps";
    //Whatsapp web routes
    APIPathFragments["START"] = "start";
    APIPathFragments["STOP"] = "stop";
    APIPathFragments["SEND"] = "send";
    APIPathFragments["RECEIVE"] = "receive";
    APIPathFragments["AUTH"] = "auth";
    APIPathFragments["STATUS"] = "status";
})(APIPathFragments = exports.APIPathFragments || (exports.APIPathFragments = {}));
